import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden pt-14">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20composition%20of%20various%20fashion%20accessories%20hats%20sunglasses%20wallets%20and%20scarves%20arranged%20on%20a%20light%20oak%20wood%20surface%20with%20soft%20morning%20sunlight%20streaming%20from%20the%20left%20side%20casting%20gentle%20golden%20shadows%20minimalist%20editorial%20photography%20warm%20inviting%20tones%20clean%20negative%20space%20around%20the%20products%20sophisticated%20lifestyle%20aesthetic%20high%20end%20catalog%20style&width=1600&height=900&seq=hero-v2-mulebuy&orientation=landscape"
          alt="Mulebuy spreadsheet product background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-white/35 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-full px-4 py-2 mb-6 md:mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs md:text-sm font-bold text-foreground-800 whitespace-nowrap">Mulebuy Spreadsheet 2026</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-[1.05] tracking-tight">
            Track<span className="text-primary-500"> / </span>
            Optimize<span className="text-primary-500"> / </span>
            Shop Smarter
          </h1>

          <p className="mt-6 md:mt-8 text-sm md:text-base text-foreground-700 leading-relaxed max-w-lg">
            The most advanced <strong className="text-foreground-950">mulebuy spreadsheet</strong> system designed to help users organize orders, 
            compare prices, and improve buying efficiency across all agent shopping platforms.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-8 md:mt-10">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-md font-bold text-sm md:text-base hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Mulebuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1 text-sm md:text-base font-semibold text-foreground-900 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap border-b-2 border-foreground-400 hover:border-foreground-800"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-8 md:mt-10 text-xs md:text-sm text-foreground-600">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center text-accent-500"><i className="ri-check-line"></i></span>
              Used worldwide
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center text-accent-500"><i className="ri-check-line"></i></span>
              Real-time tracking
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <span className="w-3 h-3 flex items-center justify-center text-accent-500"><i className="ri-check-line"></i></span>
              Optimized workflow
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}